import { ITableConfig, ITableRowConfig } from 'components/Table/types';

export const MODELS_PER_PAGE = 12;

const rowConfigs: ITableRowConfig[] = [
  { header: 'Model Name', flexValue: 1 },
  { header: 'Public', flexValue: 1 },
  { header: 'Category', flexValue: 1 },
  { header: 'ID', flexValue: 1 },
  { header: 'Version', flexValue: 1 },
  { header: 'Creation Date', flexValue: 1 },
  { header: 'Deletion', flexValue: 1 },
];

export const tableConfig: ITableConfig = {
  rowConfigs: rowConfigs,
  extraActionsFlexValue: 0.5,
};
